<template>
  <div class="page" style="height: 600px;">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="权益名称">
                  <el-input  v-model="queryForm.rightsName"></el-input>
              </el-form-item>
              <el-form-item label="权益链接">
                  <el-input  v-model="queryForm.rightsLink"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getMppGradeRightsList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addMppGradeRights"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editMppGradeRights(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteMppGradeRights(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
              :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshMppGradeRightsList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="mppGradeRightsList"
      row-key="id"
      border
      height="400px"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="rightsName"
        label="权益名称"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="rightsPic"
        label="益权图片"
        width="180"
      >
          <template slot-scope="scop">
              <div v-if='scop.row.rightsPic'>
                  <el-image
                      @click='updateSrcList(scop.row.rightsPic)'
                      style="width: 30px; height: 30px"
                      :src="scop.row.rightsPic"
                      :preview-src-list="srcList"
                  > </el-image>
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="rightsLink"
        label="权益链接"
        width="180"
      > </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="gradeId"-->
<!--        label="所属等级"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkMppGradeRights(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editMppGradeRights(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteMppGradeRights(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="mppGradeRightsStates[mppGradeRightsState]"
      :visible.sync="showDialog"
      :close-on-click-modal="false" 
      :append-to-body="true"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="mppGradeRights"
          ref="mppGradeRightsForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="权益名称"
            prop="rightsName"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="mppGradeRights.rightsName"
              :disabled="mppGradeRightsState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="益权图片"
            prop="rightsPic"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="mppGradeRights.rightsPic"-->
<!--              :disabled="mppGradeRightsState == 'check'"-->
<!--            ></el-input>-->
              <div style="width: 177px;display: flex;align-items: center;">
                  <el-input v-model="mppGradeRights.rightsPic" size="small" :disabled="mppGradeRightsState == 'check'"></el-input>
                  <el-button type="primary" :disabled="mppGradeRightsState == 'check'" size="small" style="margin-left: 2px;" @click="uploadImages()">上传图片
                      <el-upload action="" v-show="false" ref="uploads" class="avatar-uploader" :show-file-list="false"
                                 :http-request="uploadAvatar">
                          <el-button type="primary" size="small" class="as">上传</el-button>
                      </el-upload>
                  </el-button>
              </div>
          </el-form-item>
          <el-form-item
            label="权益链接"
            prop="rightsLink"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="mppGradeRights.rightsLink"
              :disabled="mppGradeRightsState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="mppGradeRightsState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    props: {
        productId: {
            type: String,
            default: ''
        }
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetMppGradeRightsList();
                    this.getMppGradeRightsList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetMppGradeRightsList();
                    this.getMppGradeRightsList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     rightsName: '', //权益名称
                     rightsLink: '', //权益链接
                     gradeId: this.productId, //所属等级
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                mppGradeRightsState: 'add',
                mppGradeRightsStates: {
                    add: '增加权益',
                    check: '查看权益',
                    edit: '修改权益'
                },

                multipleSelection: [],
                mppGradeRightsList: [],
                mppGradeRights: {
                    id: '', //ID
                    rightsName: '', //权益名称
                    rightsPic: '', //益权图片
                    rightsLink: '', //权益链接
                    gradeId: this.productId, //所属等级
                    createTime: '', //
                },
                btnLoading: false,
                srcList: [''],

                rules: {
                    rightsName: [{ required: true, message: '权益名称不能为空', trigger: 'blur' }],
                    rightsPic: [{ required: true, message: '益权图片不能为空', trigger: 'blur' }],
                    rightsLink: [{ required: true, message: '权益链接不能为空', trigger: 'blur' }],
                    gradeId: [{ required: true, message: '所属等级不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getMppGradeRightsList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetMppGradeRightsList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.mppGradeRightsList = [];
            },
            updateSrcList(src){
                this.srcList[0] = src
            },
            resetDialog() {
                this.mppGradeRightsState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      rightsName: '', //权益名称
                      rightsLink: '', //权益链接
                      gradeId: this.queryForm.gradeId, //所属等级
                };
                this.getMppGradeRightsList();
            },
            init(val){
                this.queryForm.gradeId = val;
                this.mppGradeRights.gradeId = val;
                this.resetMppGradeRightsList();
                this.getMppGradeRightsList();
            },
            uploadImages(){
                this.$refs.uploads.$el.querySelector(".as").click()
            },
            uploadAvatar(params) {
                console.log({ params });
                const file = params.file;
                let types = ['image/jpeg', 'image/png', 'image/jpg'];
                if (!types.includes(file.type)) {
                    this.$message({
                        message: '只能上传图片格式的文件，png.jpg或者jpeg',
                        type: 'error',
                        showClose: true,
                        duration: 2000
                    });
                    return;
                }
                const formData = new FormData();
                formData.append('file', file);
                console.log({ formData });
                upload(`/mpp/image/upload`, formData).then((res) => {
                    console.log({ res });
                    if (res.success) {
                        this.mppGradeRights.rightsPic = res.url;
                    }
                });
            },
            closeDialog() {
                this.showDialog = false
                this.mppGradeRights = {
                      id: '', //ID
                      rightsName: '', //权益名称
                      rightsPic: '', //益权图片
                      rightsLink: '', //权益链接
                      gradeId: this.mppGradeRights.gradeId, //所属等级
                      createTime: '', //
                };
            },
            submitForm() {
                if (this.mppGradeRightsState == 'add') {
                    this.$refs.mppGradeRightsForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/mpp/graderrights/add`,{ ...this.mppGradeRights }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetMppGradeRightsList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.mppGradeRightsState == 'edit') {
                    this.$refs.mppGradeRightsForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/mpp/graderrights/edit`,{ ...this.mppGradeRights }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetMppGradeRightsList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addMppGradeRights() {
                this.showDialog = true;
                this.mppGradeRightsState = 'add';
            },
            checkMppGradeRights(mppGradeRightsId) {
                console.log(mppGradeRightsId);
                this.currentMppGradeRightsId = mppGradeRightsId;

                this.getMppGradeRightsById();
                this.showDialog = true;
                this.mppGradeRightsState = 'check';
            },
            editMppGradeRights(mppGradeRightsId) {
                console.log('mppGradeRights', mppGradeRightsId);
                if (mppGradeRightsId) {
                    this.currentMppGradeRightsId = mppGradeRightsId;
                    this.getMppGradeRightsById();
                } else {
                    this.mppGradeRights = { ...this.mppGradeRights, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.mppGradeRightsState = 'edit';
            },
            deleteMppGradeRights(mppGradeRightsId) {
                let ids = '';
                if (mppGradeRightsId) {
                    ids = mppGradeRightsId;
                } else {
                    ids = this.multipleSelection.map((mppGradeRights) => mppGradeRights.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/mpp/graderrights/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMppGradeRightsList();
                                this.getMppGradeRightsList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshMppGradeRightsList() {
                this.resetMppGradeRightsList();
                this.getMppGradeRightsList();
            },
            getMppGradeRightsList(query = {}) {
                this.loading = true;
                get(`/mpp/graderrights/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.mppGradeRightsList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getMppGradeRightsById() {
                get(`/mpp/graderrights/get`,{ id: this.currentMppGradeRightsId }).then((res) =>{
                    if(res.success){
                      this.mppGradeRights = { ...this.mppGradeRights, ...res.mppGraderRights };
                      console.log(this.mppGradeRights,"???")
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportMppGradeRightsList() {
                //this.btnLoading = true;
                exprotExcel(`/mpp/graderrights/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/mpp/graderrights/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/mpp/graderrights/importData`,formData);
              this.refreshMppGradeRightsList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getMppGradeRightsList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getMppGradeRightsList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>